module.exports = __webpack_public_path__ + "img/World-Physio-logo-RGB.1a5a500c.svg";